import {FeedbackSelectOptions} from './type'

export const FEEDBACK_SELECT_OPTIONS: FeedbackSelectOptions[] = [
  {
    label: 'General feedback',
    value: 'general_feedback',
  },
  {
    label: 'App',
    value: 'app',
  },
  {
    label: 'SMS/email',
    value: 'sms_email',
  },
  {
    label: 'Web',
    value: 'web',
  },
  {
    label: 'Journeys',
    value: 'journeys',
  },
  {
    label: 'PA/reporting',
    value: 'pa_reporting',
  },
  {
    label: 'Experimentation',
    value: 'experimentation',
  },
]
